<template>
  <div id="app"
       :class="{
        'appMobile': this.device === 'mobile',
         'appPc': this.device === 'desktop'
       }">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .appMobile {
    margin: 0 !important;
    height: 100%;
  }
</style>
